import Icon from '@ant-design/icons'
import clsx from 'clsx'
import { createElement } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './form-item-droppable.module.scss'
import { getIcon, IconEnum } from '../../../../../assets/icons'
import { ReactComponent as TrashIcon } from '../../../../../assets/icons/trash.svg'
import { useFormBuilderStore } from '../../../../../entities/form-builder/stores/form-builder.store'
import { FormActiveItem } from '../../types/form-builder.types'
import { builderComponentConfigObjectFactory } from '../../utils/builder-component-config-factory'
import { builderComponentFactory } from '../../utils/builder-component-factory'

type FormItemDroppableBaseProps = {
  item: FormActiveItem
  required?: boolean
  isActivated: boolean
  onActivate: () => void
}

export const FormItemDroppableCard = ({ item, required, onActivate, isActivated }: FormItemDroppableBaseProps) => {
  const { t } = useTranslation()

  const changeItemPositionUp = useFormBuilderStore((state) => state.changeItemPositionUp)
  const changeItemPositionDown = useFormBuilderStore((state) => state.changeItemPositionDown)
  const deleteSelectedItem = useFormBuilderStore((state) => state.deleteSelectedItem)
  const selectedItems = useFormBuilderStore((state) => state.selectedItems)

  const componentProps = builderComponentConfigObjectFactory(item.type, item.config)
  const component = createElement(builderComponentFactory(item.type), {
    ...componentProps,
    size: 'small',
    disabled: true,
    placeholder: item.config.placeholder || t('common.placeholder'),
    label: item.config.label || t('common.defaultLabel'),
    headerplaceholder: item.config.label,
    required: item.config.required || false,
  })

  return (
    <div
      className={clsx(styles.formItemDroppableWrap, {
        [styles.formItemDroppableWrapActive]: isActivated,
      })}
      onClick={onActivate}
    >
      <div className={clsx(styles.positionControls)}>
        {isActivated ? (
          <>
            {item.seq !== 0 ? (
              <Icon
                component={getIcon(IconEnum.ArrowUp)}
                onClick={() => changeItemPositionUp(Number(item.seq))}
              />
            ) : null}
            {/*<Icon*/}
            {/*  className={clsx('mt-2')}*/}
            {/*  component={getIcon(IconEnum.DragDots)}*/}
            {/*/>*/}
            {item.seq !== selectedItems.length - 1 ? (
              <Icon
                className={clsx('mt-2')}
                component={getIcon(IconEnum.ArrowDown)}
                onClick={() => changeItemPositionDown(Number(item.seq))}
              />
            ) : null}
          </>
        ) : null}
      </div>
      <div className={clsx(styles.cardContent)}>
        <div className={clsx(styles.cardContentTop, 'd-flex justify-content-around')}>
          <Icon
            className={clsx(styles.headerItem)}
            component={getIcon(item.icon)}
          />
          <span className={clsx(styles.headerItem)}>
            {t(item.title)} {required ? <span>*</span> : null}
          </span>
          <span className={clsx(styles.cardContentControls, styles.headerItem, 'd-flex')}>
            {/*<CopyIcon />*/}
            <TrashIcon
              onClick={(e) => {
                e.stopPropagation()
                deleteSelectedItem(Number(item.seq))
              }}
            />
          </span>
        </div>
        <div className={styles.cardContentItem}>{component}</div>
      </div>
    </div>
  )
}
